/**
 * Normalizes the `protocolo` query parameter in the URL hash if it exists in the search parameters
 * but is missing from the hash. This method updates the browser history state without reloading the page.
 *
 * The method extracts the `protocolo` parameter from the search query, checks if it exists and is
 * not already present in the hash. If these conditions are met, it adds the `protocolo` parameter
 * to the hash and updates the URL using `history.replaceState`.
 *
 * @return {void} Does not return a value.
 */
export function normalizeProtocoloQueryShim() {
    if (typeof window === "undefined") {
        return;
    }

    const { hash, search, pathname } = window.location;
    if (!search || !hash.startsWith("#/")) {
        return;
    }

    const searchParams = new URLSearchParams(search);
    const protocolo = searchParams.get("protocolo");
    if (!protocolo || hash.includes("protocolo=")) {
        return;
    }

    const hashBody = hash.slice(1);
    const [hashPath, hashQuery = ""] = hashBody.split("?");
    const hashParams = new URLSearchParams(hashQuery);
    hashParams.set("protocolo", protocolo);

    const newHash = `#${hashPath}?${hashParams.toString()}`;
    history.replaceState(null, "", `${pathname}${newHash}`);
}
